async function getBlogDetail(slug) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/blogs?filters[slug][$eq]=${slug}&populate=image`,
    );
    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}

export default getBlogDetail;
